import { render, staticRenderFns } from "./AnnouncementTypeAlertCard.vue?vue&type=template&id=98080ec2&scoped=true&"
import script from "./AnnouncementTypeAlertCard.vue?vue&type=script&lang=js&"
export * from "./AnnouncementTypeAlertCard.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementTypeAlertCard.vue?vue&type=style&index=0&id=98080ec2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98080ec2",
  null
  
)

export default component.exports